import * as React from 'react';

import RenderPreviewLoading from 'bundles/compound-assessments/components/shared/embeddedContent/RenderPreviewLoading';
import RenderPreviewUnavailable from 'bundles/compound-assessments/components/shared/embeddedContent/RenderPreviewUnavailable';

type Props = {
  loading: boolean;
  fileAvailable: boolean;
  validFileSize: boolean;
  children?: React.ReactNode;
};

// Shell handling loading and availability states for file render previews
const RenderPreviewShell: React.FC<Props> = ({ loading, fileAvailable, validFileSize, children }) => {
  if (loading) {
    return <RenderPreviewLoading />;
  } else if (fileAvailable && validFileSize) {
    return <React.Fragment>{children}</React.Fragment>;
  } else {
    return <RenderPreviewUnavailable fileAvailable={fileAvailable} validFileSize={validFileSize} />;
  }
};

export default RenderPreviewShell;
